import { CameraControls } from "@react-three/drei";
import { LevaWrapper } from "@packages/r3f-gist/components";
import { Canvas } from "@react-three/fiber";
import { Scene } from "./Scene";
import { MotionEditor } from "../components/motion/MotionEditor";
import { useState, useRef } from "react";
import { ProceduralSphere } from "../components/ProceduralSphere";

export default function App() {
    const [isPlaying, setIsPlaying] = useState(false);
    const onSequenceCompleteRef = useRef<(() => void) | undefined>(undefined);
    
    const setOnSequenceComplete = (callback: () => void) => {
        onSequenceCompleteRef.current = callback;
    };
    
    const getOnSequenceComplete = () => onSequenceCompleteRef.current;

    return <>
        {/* LevaWrapper - initially hidden to avoid overlap with MotionEditor */}
        <LevaWrapper initialHidden={false} collapsed />

        {/* Motion Editor UI - positioned outside Canvas */}
        <MotionEditor 
            isPlaying={isPlaying} 
            setIsPlaying={setIsPlaying}
            onSequenceCompleteCallback={setOnSequenceComplete}
        />

        <Canvas
            gl={{ preserveDrawingBuffer: true }}
            camera={{
                fov: 45,
                near: 0.1,
                far: 200,
                position: [0, 0, 5]
            }}
        >
            <color attach="background" args={["#000000"]} />
            <Scene 
                isPlaying={isPlaying} 
                setIsPlaying={setIsPlaying}
                onSequenceComplete={getOnSequenceComplete()}
                onSequenceCompleteRef={onSequenceCompleteRef}
            />


            <ProceduralSphere />

            <CameraControls makeDefault />
        </Canvas>
    </>
}
